import styled from "styled-components";

export const Container = styled.div`
  
`;

export const ContentHeader = styled.header`
    display: flex;
    justify-content: space-between;
    padding: 0.25rem;
    width: 100%;
    background-color: var(--panel-head);
    color: var(--default-color-font);

    .infoCircleDescription-card{
        display: none;
        margin-left: 0.25rem;
    }
    &:hover{
        .infoCircleDescription-card{
            display: flex;
        }
    }
`;
